module.exports = __webpack_public_path__ + "img/slide3-768.0c1e4dbf.png";